'use client';

import type { HTMLAttributes } from 'react';
import { cx } from '@/ui/utils/cx';
import styles from './Pipeline.module.css';

export type PipelineRole = 'source' | 'transform' | 'result';

export type PipelineBranch = {
  label: string;
};

export type PipelineAfter = {
  label: string;
};

const CURVE = 'M 64 0 V 24 C 64 76, 0 68, 0 120';

export const PipelineStep = ({
  label,
  role = 'transform',
  branch,
  after,
  end = false,
  className,
  ...rest
}: {
  label: string;
  role?: PipelineRole;
  branch?: PipelineBranch;
  after?: PipelineAfter;
  end?: boolean;
} & HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(styles.step, className)} data-role={role} {...rest}>
    {role !== 'source' && (
      <div className={cx(styles.pipes, styles.pipeIn)}>
        {branch && (
          <div className={styles.branch}>
            <span
              className={cx(styles.node, styles.branchNode)}
              data-tone="source"
            >
              {branch.label}
            </span>
            <svg
              className={styles.curve}
              viewBox="0 0 64 120"
              fill="none"
              aria-hidden={true}
            >
              <path className={styles.curveBase} d={CURVE} pathLength={1} />
              <path className={styles.curveFill} d={CURVE} pathLength={1} />
            </svg>
          </div>
        )}
      </div>
    )}
    <span
      className={styles.node}
      data-tone={role === 'source' ? 'source' : 'model'}
    >
      {label}
    </span>
    {after && (
      <>
        <div className={styles.link} />
        <span className={cx(styles.node, styles.afterNode)} data-tone="model">
          {after.label}
        </span>
      </>
    )}
    {!end && role !== 'result' && (
      <div className={cx(styles.pipes, styles.pipeOut)} />
    )}
  </div>
);
